import { Disposable, IDisposable } from './Disposable';
import PSound from 'pixi-sound';
import { Game } from '../game';

/**
 * Manages a single sound effect, hooking it up to the global sfxVolume setting.
 * Note that this management isn't ideal, as one could create multiple SoundEffect objects
 * for a single pixi Sound. While this isn't dangerous, it is inefficient, as each one will listen
 * to and set the volume on the same Sound.
 */
export class SoundEffect implements IDisposable
{
    public sound: PSound.Sound;
    private volumeListener: Disposable;

    constructor(sound:PSound.Sound, game: Game)
    {
        this.sound = sound;
        this.sound.volume = game.app.state.sfxVolume.value * game.sfxVolumeMultiplier;
        this.volumeListener = Disposable.fromPropertySubscription(game.app.state.sfxVolume, (value) => {
            this.sound.volume = value * game.sfxVolumeMultiplier;
        });
    }

    public async play()
    {
        let instance: PSound.IMediaInstance|Promise<PSound.IMediaInstance>;
        let complete = new Promise<void>(resolve => {
            instance = this.sound.play(() => resolve());
        });
        await instance
        return complete;
    }

    public dispose()
    {
        if (!this.sound) return;

        // don't destroy the sound - because we didn't load it here, we assume it will be
        // unloaded elsewhere
        this.sound = null;
        this.volumeListener.dispose();
        this.volumeListener = null;
    }

    public destroy()
    {
        this.dispose();
    }
}